import React from 'react';
import { FormControl, FormHelperText, InputLabel, MenuItem, Select } from '@material-ui/core';

const UIBuilderCustomSelect = (props) => {
  const {
    value,
    handleInputChange,
    options,
    label,
    labelField,
    valueField,
    hideNullOption,
    nullOptionLabel,
    disabled,
    required,
    error,
    errorMessage,
  } = props;

  const onChange = (e) => {
    handleInputChange(e);
  };

  return (
    <FormControl className='w-100' error={error} required={required}>
      <InputLabel id='hotel-module-'>{label || 'Select'}</InputLabel>
      <Select
        disabled={disabled}
        labelId='hotel_module_label'
        id='hotel_module_select'
        autoWidth={false}
        value={value}
        onChange={(e) => {
          onChange(e);
        }}
        MenuProps={{
          anchorOrigin: {
            vertical: 'bottom',
            horizontal: 'left',
          },
          getContentAnchorEl: null,
        }}
      >
        {!hideNullOption && (
          <MenuItem value=''>
            <em>{nullOptionLabel || 'None'}</em>
          </MenuItem>
        )}

        {options.map((item, key) => {
          return (
            <MenuItem key={key} value={item[valueField || 'id']}>
              {item[labelField || 'name']}
            </MenuItem>
          );
        })}
      </Select>
      <FormHelperText>{error ? errorMessage || '' : ''}</FormHelperText>
    </FormControl>
  );
};

export default UIBuilderCustomSelect;
